








































import Vue from "vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ValidationProvider, extend, ValidationObserver } from "vee-validate";
import {
  required,
  confirmed,
  numeric,
  min,
  max
} from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "Vui lòng điền đầy đủ thông tin!"
});
extend("numeric", {
  ...numeric,
  message: "Vui lòng nhập số!"
});
extend("min", {
  ...min,
  message: "Vui lòng nhập đủ 6 số!"
});
extend("max", {
  ...max,
  message: "Vui lòng nhập đủ 6 số!"
});
extend("confirmed", {
  ...confirmed,
  message: "Mật khẩu không đồng nhất!"
});

export default Vue.extend({
  name: "UpdatePinModal",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapGetters({
      showModal: "updatePin/showModalUpdate",
      agencyCode: "updatePin/agencyCode",
      doing: "updatePin/doing",
      mode: "updatePin/getMode",
      farmerId: "updatePin/getFarmerId"
    })
  },
  methods: {
    handleCancel() {
      this.pin = "";
      this.pinConfirm = "";
      this.setChangePassModal(false);
      this.resetModal();
    },
    async handleChangePin() {
      const data = {
        code: this.agencyCode,
        pin: this.pin
      };
      if (this.mode == "farmer") {
        const payload = await this.changePinFarmer({
          id: this.farmerId,
          pin: this.pin
        });
        if (payload) this.handleCancel();
      } else {
        const payload = await this.changePin(data);
        if (payload) this.handleCancel();
      }
    },
    ...mapMutations({
      setChangePassModal: "updatePin/handleShowModal",
      resetModal: "updatePin/resetModal"
    }),
    ...mapActions({
      changePin: "updatePin/changePin",
      changePinFarmer: "updatePin/changePinFarmer"
    })
  },
  data() {
    return {
      pin: "",
      pinConfirm: ""
    };
  }
});
